import styles from "./FAQItem.module.css";
import { CSSProperties } from "react";

interface FAQItemProps {
  category: string;
  question: string;
  answer: string;
  style?: CSSProperties;
}

export const FAQItem = ({ category, question, answer, style }: FAQItemProps) => {
  return (
    <div className={styles.faqItem} style={style}>
      <div className={styles.category}>{category}</div>
      <h3 className={styles.question}>{question}</h3>
      <p className={styles.answer}>{answer}</p>
    </div>
  );
};
